import * as types from './mutation_types';

export default {
  [types.DASHBOARD_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.DASHBOARD_RESET](state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      items: [],
      user: {},
    });
  },

  [types.DASHBOARD_SET_LOADING](state, loading) {
    Object.assign(state, { isLoading: loading });
  },

  [types.DASHBOARD_SET_ITEMS](state, items) {
    Object.assign(state, { items });
  },

  [types.DASHBOARD_SET_USER](state, user) {
    Object.assign(state, { user });
  },
};
